export function formatToUTCISOString(
  year: number,
  month: number,
  date: number,
  hour: number,
  minute: number,
  second?: number,
) {
  return new Date(
    new Date(year, month - 1, date, hour, minute, second || 0).toUTCString(),
  ).toISOString();
}
